export default {
    clearLocalStorage({commit}) {
        return new Promise((resolve) => {
            const cliente = JSON.parse(localStorage.getItem('cliente'))
            localStorage.clear()
            commit('clearLocalStorage', cliente)
            resolve(cliente)
        })
    },
    createNotification({commit}, params) {
        return new Promise(resolve => {
            params.resolve = resolve
            commit('createNotification', params)
        })
    },
    setCliente({commit}, cliente) {
        localStorage.setItem('cliente', JSON.stringify(cliente))
        commit('setCliente', cliente)
    },
    setDatetime({commit}, datetime) {
        localStorage.setItem('datetime', datetime)
        commit('setDatetime', datetime)
    },
    setExpiration({commit}, expiration) {
        localStorage.setItem('expiration', expiration)
        commit('setExpiration', expiration)
    },
    setLoading: ({commit}, local) => commit('setLoading', local),
    setModulos({commit}, modulos) {
        localStorage.setItem('modulos', JSON.stringify(modulos))
        commit('setModulos', modulos)
    },
    setNotification: ({commit}, params) => commit('setNotification', params),
    setSidebar({commit}, value) {
        localStorage.setItem('sidebar', value)
        commit('setSidebar', value)
    },
    setToken({commit}, token) {
        localStorage.setItem('token', token)
        commit('setToken', token)
    },
    setUsuario({commit}, usuario) {
        localStorage.setItem('usuario', JSON.stringify(usuario))
        commit('setUsuario', usuario)
    },
    unsetLoading: ({commit}) => commit('unsetLoading'),
}